import {
    useAPIQuery,
    useGlobalAPIQueryContext,
} from "@dev2_techwalnut/tw-api-query-hook";
import { Fragment, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import secureLocalStorage from "react-secure-storage";

const UpdateOnHoldModal = ({ currentQCReportData }) => {
    console.log(currentQCReportData);
    const closeModalButtonRef = useRef(null);
    const handleCloseModal = () => {
        if (closeModalButtonRef.current) {
            closeModalButtonRef.current.click();
        }
    };
    const userID = secureLocalStorage.getItem("userID");
    const { invalidateApi } = useGlobalAPIQueryContext();

    const onHoldCount =
        currentQCReportData?.daily_plan?.on_hold_count ||
        currentQCReportData?.batch?.on_hold_count ||
        0;

    const { useUpdate: updateQCBatch } = useAPIQuery({
        key: "qc-batch-dropdown",
        endpoint: "/api/check-batch/",
    });

    const { mutate: updateQcBatchData, isPending: updatingQCBatch } =
        updateQCBatch({
            successMessageFromServer: true,
            errorMessageFromServer: true,
            onSuccess: () => {
                invalidateApi({ key: "qc-report" });
                invalidateApi({ key: "api/check-batch" });
                handleCloseModal();
                reset({
                    accepted_count: 0,
                    rejection_count: 0,
                });
            },
            onError: () => {
                invalidateApi({ key: "qc-report" });
                invalidateApi({ key: "api/check-batch" });
            },
        });

    const {
        handleSubmit,
        register,
        watch,
        reset,
        setError,
        clearErrors,
        formState: { errors },
    } = useForm({ mode: "onBlur" });

    const accepted = watch("accepted_count");
    const rejected = watch("rejection_count");
    const onHold =
        onHoldCount - (Number(accepted || 0) + Number(rejected || 0));

    console.log(onHold);

    const onSubmit = (data) => {
        const total =
            Number(data.accepted_count || 0) +
            Number(data.rejection_count || 0);

        if (onHoldCount !== undefined && total > onHoldCount) {
            setError("combined_total", {
                type: "manual",
                message: `The combined total (${total}) cannot exceed the on hold count (${onHoldCount}).`,
            });
            return;
        }

        clearErrors("combined_total");
        console.log("✅ Submitted:", data);

        updateQcBatchData({
            id: currentQCReportData?.id,
            data: {
                accepted_count: Number(data.accepted_count || 0),
                rejection_count: Number(data.rejection_count || 0),
                on_hold_count: Number(onHold),
                updated_by: userID,
            },
        });
    };

    // Watch input values and validate live
    useEffect(() => {
        if (onHoldCount === undefined) return;

        const total = Number(accepted || 0) + Number(rejected || 0);

        if (total > onHoldCount) {
            setError("combined_total", {
                type: "manual",
                message: `The combined total (${onHoldCount}) cannot exceed the on hold count (${onHoldCount}).`,
            });
        } else {
            clearErrors("combined_total");
        }
    }, [accepted, rejected, onHoldCount, setError, clearErrors]);

    // Reset form with defaults
    useEffect(() => {
        if (onHoldCount !== undefined) {
            reset({
                accepted_count: 0,
                rejection_count: 0,
            });
        }
    }, [reset]);

    // Clean modal backdrops on unmount
    useEffect(() => {
        return () => {
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
                document.body.classList.remove("modal-open");
                document.body.style = "";
            }
        };
    }, []);

    return (
        <Fragment>
            <div
                className="modal fade m-0 p-0"
                tabIndex={-1}
                id="update-on-hold-modal"
                aria-modal="true"
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <button
                            className="close"
                            data-bs-dismiss="modal"
                            id="po_modal_close_btn"
                            ref={closeModalButtonRef}
                        >
                            <em
                                className="icon ni ni-cross"
                                aria-hidden="true"
                            ></em>
                        </button>
                        <div className="modal-header">
                            <h5 className="modal-title">Update On Hold</h5>
                        </div>

                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="modal-body">
                                {errors.combined_total && (
                                    <div className="alert alert-danger py-2">
                                        {errors.combined_total.message}
                                    </div>
                                )}

                                <div className="alert alert-info">
                                    On Hold Count: {onHold}
                                </div>

                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <label className="form-label">
                                            Accept Count
                                            <span className="ms-1 fs-8 text-danger">
                                                *
                                            </span>
                                        </label>
                                        <input
                                            type="number"
                                            step={"any"}
                                            className="form-control"
                                            placeholder="Enter accepted count"
                                            {...register("accepted_count", {
                                                required:
                                                    "Accepted count is required",
                                                validate: {
                                                    positive: (v) =>
                                                        v >= 0 ||
                                                        "Only positive numbers are allowed",
                                                },
                                                max: {
                                                    value: onHoldCount,
                                                    message: `Accepted count cannot be more than on hold count (${onHoldCount})`,
                                                },
                                            })}
                                            onWheel={(e) => e.target.blur()}
                                        />
                                        {errors.accepted_count && (
                                            <span className="fs-8 text-danger">
                                                {errors.accepted_count.message}
                                            </span>
                                        )}
                                    </div>

                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <label className="form-label">
                                            Rejection Count
                                            <span className="ms-1 fs-8 text-danger">
                                                *
                                            </span>
                                        </label>
                                        <input
                                            type="number"
                                            step={"any"}
                                            className="form-control"
                                            placeholder="Enter rejection count"
                                            {...register("rejection_count", {
                                                required:
                                                    "Rejection count is required",
                                                validate: {
                                                    positive: (v) =>
                                                        !v ||
                                                        v >= 0 ||
                                                        "Only positive numbers are allowed",
                                                },
                                                max: {
                                                    value: onHoldCount,
                                                    message: `Rejected count cannot be more than on hold count (${onHoldCount})`,
                                                },
                                            })}
                                            onWheel={(e) => e.target.blur()}
                                        />
                                        {errors.rejection_count && (
                                            <span className="fs-8 text-danger">
                                                {errors.rejection_count.message}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={
                                        !!errors.combined_total ||
                                        updatingQCBatch
                                    }
                                >
                                    {updatingQCBatch
                                        ? "Submitting..."
                                        : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default UpdateOnHoldModal;
